import { DbValidateTransfer } from "../../../data/usecases/validate-transfer";

import { ValidateTransfer } from "../../../domain/usecases/validate-transfer";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl } from "../http";

export const makeValidateTransfer = (): ValidateTransfer =>
  new DbValidateTransfer(
    makeApiUrl("/transfer/validate"),
    makeAuthorizeHttpClientDecorator()
  );
